import { useEffect, useRef } from 'react'

/** A ref that always holds the latest render's value, for callbacks that outlive the render they were made in. */
export function useLatest<T>(value: T) {
  const latest = useRef(value)
  useEffect(() => {
    latest.current = value
  })
  return latest
}
